import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Tbody, Td, Th, Thead, Tr, Tabs, TabPanels, TabPanel } from "@chakra-ui/react";
import "./style.scss";
import Loader from "~components/Form/components/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import { AddButton } from "~misc/icons";
import { money } from "~hooks/useHelpers";
import usePrazoRegra from "~fetchs/usePrazoRegra";

const ContainerDaTabelaPrecoRegra = ({
  handleAddButton,
  filters,
  onFiltros,
  setEstadoFiltro,
  estadoFiltro,
  total,
  totalRenderizado,
  precosRegra,
  loading,
  setSkip,
  take,
}) => {
  const [visibility, setVisibility] = useState(null);

  const { prazoRegras } = usePrazoRegra({ filters });

  const loadMoreItems = () => {
    setSkip((prevSkip) => prevSkip + take);
  };

  useEffect(() => {
    setVisibility(onFiltros.microrregiao);
  }, [onFiltros]);

  const handleTabChange = (index) => {
    setEstadoFiltro(index);
  };

  const [displayedItems, setDisplayedItems] = useState(10);
  const [loadingp, setLoadingp] = useState(false);

  const loadMoreItemsp = () => {
    if (estadoFiltro === 1) {
      setLoadingp(true);
      setDisplayedItems((prev) => prev + 10);
      setLoadingp(false);
    }
  };

  return (
    <>
      <div className="container mx-auto">
        <Tabs variant="enclosed" isFitted index={estadoFiltro} onChange={handleTabChange}>
          <TabPanels>
            <TabPanel>
              {visibility && estadoFiltro === 0 ? (
                <>
                  <InfiniteScroll
                    dataLength={totalRenderizado}
                    next={loadMoreItems}
                    hasMore={total > totalRenderizado}
                    loader={loading && <Loader />}
                    endMessage={
                      precosRegra && (precosRegra || []).length > 0 ? <p className="text-center">Fim da lista</p> : null
                    }
                  >
                    <main className="prices-table-table mt-0">
                      <div className="container content"></div>
                      <div className="accordion">
                        <div>
                          <div>
                            <div>
                              {precosRegra.map((content, contentIndex) => (
                                <div key={contentIndex}>
                                  <div className="table-container">
                                    <div className="show-on-sticky"></div>

                                    <Table className="table">
                                      <Thead>
                                        <Tr>
                                          <Th>{content.header.title}</Th>
                                          <Th>Cluster</Th>
                                          <Th>Cidade</Th>
                                          <Th>
                                            FOB <small>(R$/un)</small>
                                          </Th>
                                          <Th>
                                            CIF <small>(R$/un)</small>
                                          </Th>
                                          <Th></Th>
                                        </Tr>
                                      </Thead>

                                      <Tbody>
                                        {content.produtos.map((row, rowIndex) => (
                                          <Tr key={rowIndex}>
                                            <Td style={{ width: "500px", marginTop: "1rem" }}>
                                              {row.codigoProduto} - {row.descricaoProduto}
                                            </Td>

                                            <Td style={{ width: "100px", marginTop: "1rem" }}>
                                              {row.nomeCluster ?? "Todos"}
                                            </Td>

                                            <Td style={{ width: "100px", marginTop: "1rem" }}>
                                              {row.nomeCidade ?? "Todas"}
                                            </Td>

                                            <Td>{money(row.valorPrecoFOB)}</Td>
                                            <Td>{money(row.valorPrecoCIF)}</Td>
                                            <Td className="action-buttons-column">
                                              <div className="action-buttons-row">
                                                <button
                                                  type="button"
                                                  onClick={() =>
                                                    handleAddButton(row.grupoMaterialId, row.produtoId, row.filialId)
                                                  }
                                                  className="action-button"
                                                >
                                                  <AddButton className="icon" fill="#FFF" size={18} />
                                                </button>
                                              </div>
                                            </Td>
                                          </Tr>
                                        ))}
                                      </Tbody>
                                    </Table>
                                  </div>
                                </div>
                              ))}
                            </div>
                            {precosRegra &&
                              (precosRegra || []).length === 0 &&
                              (filters.grupoProduto !== 0 ||
                              filters.produto !== 0 ||
                              filters.filial !== 0 ||
                              filters.cidade !== 0 ||
                              filters.microrregiao !== 0 ||
                              filters.grupoSegmento !== 0 ||
                              filters.segmento !== 0 ||
                              filters.cluster !== 0 ? (
                                <p className="text-center">Nenhum resultado encontrado</p>
                              ) : (
                                <p className="text-center">Não há informações cadastradas para esses filtros</p>
                              ))}
                          </div>
                        </div>
                      </div>
                    </main>
                  </InfiniteScroll>
                </>
              ) : (
                <>
                  <h2 className="text-xl font-bold text-center pt-10">Selecione pelo menos uma microrregião!</h2>
                </>
              )}
            </TabPanel>
            <TabPanel>
              {estadoFiltro === 1 && (
                <>
                  <InfiniteScroll
                    dataLength={displayedItems}
                    next={loadMoreItemsp}
                    hasMore={displayedItems < prazoRegras.length}
                    endMessage={prazoRegras.length > 0 ? <p className="text-center">Fim da lista</p> : null}
                    loader={loadingp && <Loader />}
                  >
                    <main className="prices-table-table mt-0 max-w-[1000px] !mx-auto">
                      <div className="container content"></div>
                      <div className="accordion">
                        <div>
                          <div>
                            <div>
                              {prazoRegras.slice(0, displayedItems).map((content, contentIndex) => (
                                <div key={contentIndex}>
                                  <div className="table-container">
                                    <div className="show-on-sticky"></div>

                                    <Table className="table">
                                      <Thead>
                                        <Tr>
                                          <Th>{content.grupoSegmentoNome}</Th>
                                          <Th>Prazo</Th>
                                        </Tr>
                                      </Thead>
                                      <Tbody>
                                        {content.familias.map((row, rowIndex) => (
                                          <Tr key={rowIndex}>
                                            <Td style={{ width: "500px", marginTop: "1rem" }}>{row.nome}</Td>

                                            <Td className="dias">{content.dias} Dias</Td>
                                          </Tr>
                                        ))}
                                      </Tbody>
                                    </Table>
                                  </div>
                                </div>
                              ))}
                              {prazoRegras.length === 0 &&
                                (filters.grupoProduto !== 0 || filters.familia !== 0 ? (
                                  <p className="text-center">Nenhum resultado encontrado</p>
                                ) : (
                                  <p className="text-center">Não há informações cadastradas para esses filtros</p>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </main>
                  </InfiniteScroll>
                </>
              )}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </>
  );
};

ContainerDaTabelaPrecoRegra.propTypes = {
  handleAddButton: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  onFiltros: PropTypes.object.isRequired,
  setEstadoFiltro: PropTypes.func.isRequired,
  estadoFiltro: PropTypes.number.isRequired,
  total: PropTypes.number,
  totalRenderizado: PropTypes.number,
  precosRegra: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  setSkip: PropTypes.func.isRequired,
  take: PropTypes.number.isRequired,
};

export default ContainerDaTabelaPrecoRegra;
